var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "right",
            "label-width": "95px",
            size: "small"
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 0 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("i18n_contact_person") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            "box-sizing": "border-box"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.countLIst_D.name == "",
                                  expression: "countLIst_D.name == ''"
                                }
                              ],
                              staticClass: "poperWrap"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("i18n_No_default_contact")) +
                                  "\n              "
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addNewpop(1)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("i18n_add")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.countLIst_D.name,
                                  expression: "countLIst_D.name"
                                }
                              ],
                              staticClass: "thatpoperWrap"
                            },
                            [
                              _c("div", { staticClass: "popWrap_l" }, [
                                _c("p", { staticClass: "lianxiren" }, [
                                  _vm._v(_vm._s(_vm.countLIst_D.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticStyle: { "margin-left": "12px" } },
                                  [_vm._v(_vm._s(_vm.countLIst_D.tel))]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "popWrap_R" },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.countLIst_D.isdefault,
                                          expression: "countLIst_D.isdefault"
                                        }
                                      ],
                                      staticClass: "morentype"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("i18n_default_address"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.countLIst_D.isdefault,
                                          expression: "!countLIst_D.isdefault"
                                        }
                                      ],
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.changeshowType(
                                            1,
                                            _vm.countLIst_D,
                                            "loca"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("i18n_set_to_default_address")
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.UpItem(1, _vm.countLIst_D)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#604aff" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addNewpop(1)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("i18n_add")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showTui,
                                    expression: "showTui"
                                  }
                                ]
                              },
                              _vm._l(_vm.TuipopList, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "poperWrap",
                                    on: {
                                      click: function($event) {
                                        return _vm.changeFAitem(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "popWrap_l" }, [
                                      _c("p", { staticClass: "lianxiren" }, [
                                        _vm._v(_vm._s(item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { "margin-left": "12px" }
                                        },
                                        [_vm._v(_vm._s(item.tel))]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "popWrap_R" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: item.isdefault,
                                                expression: "item.isdefault"
                                              }
                                            ],
                                            staticClass: "morentype"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("i18n_default_address")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !item.isdefault,
                                                expression: "!item.isdefault"
                                              }
                                            ],
                                            staticStyle: { color: "#604aff" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.changeshowType(
                                                  1,
                                                  item,
                                                  "ajax"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "i18n_set_to_default_address"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#604aff" },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.UpItem(1, item)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.TuipopList.length > 1,
                              expression: "TuipopList.length > 1"
                            }
                          ],
                          staticStyle: { margin: "10px 0 0 10px" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#696969" },
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  _vm.showTui = !_vm.showTui
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.showTui
                                      ? "i18n_Collapse"
                                      : "i18n_more_contact_information"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("span", {
                            class: _vm.showTui
                              ? "el-icon-arrow-up"
                              : "el-icon-arrow-down"
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            width: "420px",
            visible: _vm.addressDialogVisible,
            closeOnClickModal: false,
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addressDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "wrap_count" }, [
            _c("div", { staticClass: "header_logo" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      !this.itemid
                        ? "i18n_Create_new_address"
                        : "i18n_Modify_Address"
                    )
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "count" },
              [
                _c(
                  "el-form",
                  {
                    ref: "editAddress",
                    attrs: {
                      "label-position": "right",
                      "label-width": "80px",
                      rules: _vm.fromPopRules,
                      model: _vm.fromPop
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("i18n_contact_person"),
                          prop: "name"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.addPls("i18n_Name", "input")
                          },
                          model: {
                            value: _vm.fromPop.name,
                            callback: function($$v) {
                              _vm.$set(_vm.fromPop, "name", $$v)
                            },
                            expression: "fromPop.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("i18n_contact_info"),
                          prop: "tel"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.addPls(
                              "i18n_contact_info",
                              "input"
                            )
                          },
                          model: {
                            value: _vm.fromPop.tel,
                            callback: function($$v) {
                              _vm.$set(_vm.fromPop, "tel", $$v)
                            },
                            expression: "fromPop.tel"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.changeNum == 2
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("i18n_contact_address"),
                              prop: "ssqnames"
                            }
                          },
                          [
                            _c("el-cascader", {
                              ref: "refSsqname",
                              staticStyle: { width: "100%" },
                              attrs: {
                                options: _vm.Guojialist,
                                props: _vm.defaultParams
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.namec))
                                        ]),
                                        _vm._v(" "),
                                        !node.isLeaf ? _c("span") : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3298384561
                              ),
                              model: {
                                value: _vm.fromPop.ssqnames,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "ssqnames", $$v)
                                },
                                expression: "fromPop.ssqnames"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.changeNum == 3
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("i18n_contact_address"),
                              prop: "ssqnames"
                            }
                          },
                          [
                            _c("el-cascader", {
                              ref: "refSsqname",
                              staticStyle: { width: "100%" },
                              attrs: {
                                options: _vm.citylist,
                                props: _vm.defaultParams
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(data.namec))
                                        ]),
                                        _vm._v(" "),
                                        !node.isLeaf ? _c("span") : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3298384561
                              ),
                              model: {
                                value: _vm.fromPop.ssqnames,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "ssqnames", $$v)
                                },
                                expression: "fromPop.ssqnames"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.changeNum != 1,
                            expression: "changeNum != 1"
                          }
                        ]
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.addPls(
                              "i18n_Detailed_address",
                              "input"
                            ),
                            type: "textarea"
                          },
                          model: {
                            value: _vm.fromPop.address,
                            callback: function($$v) {
                              _vm.$set(_vm.fromPop, "address", $$v)
                            },
                            expression: "fromPop.address"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "type" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.fromPop.isdefault,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "isdefault", $$v)
                              },
                              expression: "fromPop.isdefault"
                            }
                          },
                          [
                            _c("el-checkbox", { attrs: { name: "type" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("i18n_set_to_default_address"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(_vm.itemid ? "i18n_edit" : "i18n_add")
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.addressDialogVisible = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_cancel")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c46d6006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c46d6006","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/component/addressInfoDeclarer.vue
// module id = null
// module chunks = 